/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_QUIZZ } from "./actionTypes"
import { apiError, addQuizzSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addQuizz } from "../../../helpers/backend_helper"

function* add(request) {
  try {
    const response = yield call(addQuizz, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(addQuizzSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* quizzAddSaga() {
  yield takeEvery(ADD_QUIZZ, add)
}

export default quizzAddSaga
